import administracion from "./Administracion/administracion"
import consultas from "./Consultas/consultas"

const regop = {
  administracion: administracion,  
  consultas: consultas
}

export default regop


//////////////////
// WEBPACK FOOTER
// ./static/js/api/REGOP/Sistema/sistemaREGOP.js
// module id = null
// module chunks = 